import React from 'react'
import { useSelector } from 'react-redux'

import { Box, Typography } from '@material-ui/core'

import { AddressType } from '../models/address.model'
import { selectAddressSummary } from '../store/address.selectors'

import { RootState } from '~/core/store/root.reducer'
import ModifyButton from '~/ui/components/ModifyButton/ModifyButton'

export default function AddressSummary({
  id,
  addressType,
}: {
  id: string
  addressType: AddressType
}) {
  const address = useSelector((state: RootState) => selectAddressSummary(state, id, addressType))

  return (
    <Box data-hook={`address-summary-${id}`}>
      <Typography variant="subtitle1">DIRECCIÓN DE ENTREGA DE LA SIM</Typography>
      <Box display="flex" flexDirection="row" alignItems="baseline" mt={5} mb={4}>
        <Typography variant="body2">Dirección: </Typography>
        <Box ml={1}>
          <Typography variant="subtitle2">{address}</Typography>
        </Box>
      </Box>
      <ModifyButton text="Modificar Dirección de Entrega" />
    </Box>
  )
}
